// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IStatusDto
 */
export interface IStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IStatusDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IStatusDto
     */
    type_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IStatusDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IStatusDto interface.
 */
export function instanceOfIStatusDto(value: object): value is IStatusDto {
    return true;
}

export function IStatusDtoFromJSON(json: any): IStatusDto {
    return IStatusDtoFromJSONTyped(json, false);
}

export function IStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type_code': json['type_code'] == null ? undefined : json['type_code'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IStatusDtoToJSON(json: any): IStatusDto {
    return IStatusDtoToJSONTyped(json, false);
}

export function IStatusDtoToJSONTyped(value?: IStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type_code': value['type_code'],
        'description': value['description'],
    };
}

